<h1 mat-dialog-title>Order Products Without a Tag</h1>
<mat-dialog-content class="coverage-content">
  <p class="lead-copy">
    These order products don't fire any reservation tag when added to an
    invoice. Click <b>Wire a tag</b> to create a new tag pre-linked to the OP,
    or open an existing tag in the Tags view and set its OP trigger.
  </p>

  @if (loading) {
    <div class="loading-row">
      <i class="pi pi-spin pi-spinner"></i> Loading order products…
    </div>
  } @else {
    <mat-form-field class="search-field" appearance="outline">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Filter by OP name or id…" [(ngModel)]="searchTerm" />
    </mat-form-field>

    @if (filteredUncoveredOps.length === 0) {
      <div class="empty-state">
        @if (searchTerm) {
          No order products match your filter.
        } @else {
          <i class="pi pi-check-circle" style="color:#16a34a; margin-right:6px;"></i>
          Every order product has at least one tag wired. Nice coverage.
        }
      </div>
    } @else {
      <ul class="op-list">
        @for (op of filteredUncoveredOps; track op.orderProductId) {
          <li class="op-row">
            <div class="op-meta">
              <span class="op-name">{{ op.name }}</span>
              <small class="op-id">id {{ op.orderProductId }}</small>
            </div>
            <button mat-stroked-button color="primary" type="button"
                    (click)="onWireTag(op)">
              <mat-icon class="btn-icon">link</mat-icon>
              Wire a tag
            </button>
          </li>
        }
      </ul>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
